import { host } from '../config/env'
export default {
  saveTopic: `${host.mtopic}/m/topicelement/add-topic-element`,
  getTopic: `${host.mtopic}/m/topicelement/getmalltopicelement`,
  checkexist: `${host.mtopic}/m/topic/config/checkexist`,
  getProducts: `${host.mtopic}/m/topic/config/product`,
  getEqxLayoutVersion: `${host.mtopic}/m/config/navigation/getEqxLayOutVersion`,
  checkShowker: `${host.mall}/api/showker/checkShowker`,
  addFavorite: `${host.favorite}/m/favorite/add-favorite`,
  packageProductUrl: `${host.mtopic}/m/topic/package/packageProduct`,
  getWxShareInfoUrl: `${host.mtopic}/wechat/sign-data`
}
